import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { VerificationService, assertValidSegmentName } from '@sheerid/jslib';

import { LIST_ITEM_NUMBER_THREE } from '../../lib/constants';

interface Props {
    verificationService: VerificationService;
}

const AcceptableLicenseUploadsComponent: React.SFC<Props> = ({ verificationService }) => {
    const { segment } = verificationService.verificationResponse;
    assertValidSegmentName(segment);

    return (
        <div>


            <ol className="sid-acceptable-uploads-list">
                    <li className="sid-acceptable-uploads-list__li">
                        <FormattedHTMLMessage
                            id="step.docUpload.acceptableUploads.one"
                            defaultMessage="License file as it appears on your project's detail page"
                        />
                    </li>

                    <li className="sid-acceptable-uploads-list__li">
                        <FormattedHTMLMessage
                            id="step.docUpload.acceptableUploads.two"
                            defaultMessage="Text file uploaded to GitLab containing your license"
                        />
                    </li>
                </ol>

                <ol className="sid-acceptable-uploads-list" start={LIST_ITEM_NUMBER_THREE}>
                    <li className="sid-acceptable-uploads-list__li">
                        <FormattedHTMLMessage
                            id="step.docUpload.acceptableUploads.three"
                            defaultMessage="Your publicly visible settings under the Visibility, project features, permissions section of the project\'s admin panel"
                        />
                    </li>

                </ol>
                <span>
                    <FormattedHTMLMessage
                        id="step.docUpload.acceptableUploads.instructions"
                        defaultMessage='<a href="https://docs.gitlab.com/ee/subscriptions/community_programs.html#gitlab-for-open-source" class="sid-link" target="_blank" rel="noopener noreferrer">See instructions for taking required screenshots</a>' />
            </span>
        </div>
    );
};

export { AcceptableLicenseUploadsComponent };
